<div class="app-init-loader-animation"><img src="assets/img/loading.gif" alt=""></div>
<div class="app-init-loader-text">{{ 'components.loader.loading' | translate }}</div>